import { useEffect, useState } from 'react'
import { useSite } from '../context/SiteContext.jsx'
import { bannerHref } from '../lib/utm.js'

/*
 * Rotating banner/ad strip for the top of the calculator page. Content is
 * managed by admins at /admin/banners. Renders nothing when there are none,
 * so the page is unaffected until you add one.
 */
export default function CalculatorBanner() {
  const { activeBanners } = useSite()
  const [i, setI] = useState(0)

  useEffect(() => {
    if (activeBanners.length < 2) return
    const t = setInterval(() => setI((n) => (n + 1) % activeBanners.length), 6000)
    return () => clearInterval(t)
  }, [activeBanners.length])

  if (activeBanners.length === 0) return null
  const b = activeBanners[i % activeBanners.length]

  const inner = (
    <>
      <picture>
        {b.mobile_image_url && <source media="(max-width: 640px)" srcSet={b.mobile_image_url} />}
        <img src={b.image_url} alt={b.caption || 'Sponsor'} loading="lazy" />
      </picture>
      {b.caption && <span className="cbanner-caption">{b.caption}</span>}
      {activeBanners.length > 1 && (
        <span className="cbanner-dots">
          {activeBanners.map((_, n) => <span key={n} className={n === i ? 'on' : ''} />)}
        </span>
      )}
    </>
  )

  const href = bannerHref(b)
  return (
    <div className="cbanner fade-in">
      {href ? (
        <a href={href} target="_blank" rel="noopener noreferrer sponsored">{inner}</a>
      ) : (
        inner
      )}
    </div>
  )
}
